<template>
  <transition name="bounce">
    <div class="alert-container" v-if="open">
      <v-alert :type="alert.type"
        >{{ alert.message }}</v-alert
      >
    </div>
  </transition>
</template>

<script>
import { closeAlert } from '../../utils/alert-funcitons'
export default {
  name: "AlertComponent",
  watch:{
    open(){
      if(this.open) {
        setTimeout(() => {
          closeAlert();
        }, 3000)
      }
    }
  },
  computed: {
    alert: {
      get() {
        return this.$store.state.alert;
      },
    },
    open: {
      get() {
        return this.$store.state.alert.open;
      },
    }
  },
};
</script>

<style scoped>
.alert-container {
  width: fit-content;
  position: fixed;
  z-index: 2000;
  margin: 2rem;
  right: 0;
}
</style>